/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ResourceType;
(function (ResourceType) {
    ResourceType["Network"] = "NETWORK";
    ResourceType["Location"] = "LOCATION";
    ResourceType["Player"] = "PLAYER";
    ResourceType["Campaign"] = "CAMPAIGN";
    ResourceType["Content"] = "CONTENT";
    ResourceType["ContentBundle"] = "CONTENT_BUNDLE";
    ResourceType["Organisation"] = "ORGANISATION";
    ResourceType["User"] = "USER";
    ResourceType["ApiDocs"] = "API_DOCS";
    ResourceType["Tag"] = "TAG";
    ResourceType["Role"] = "ROLE";
    ResourceType["System"] = "SYSTEM";
    ResourceType["AccessGrant"] = "ACCESS_GRANT";
    ResourceType["Any"] = "ANY";
})(ResourceType || (ResourceType = {}));
export function ResourceTypeFromJSON(json) {
    return ResourceTypeFromJSONTyped(json, false);
}
export function ResourceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ResourceTypeToJSON(value) {
    return value;
}
